import Normalizer from './NormalizerContext'
import ScoreRatingItem from './ScoreRatingItem'
import normalizerHooks from './hooks'
import ApplyDataConfirmation from './ApplyDataConfirmation'
import ScoreRatingTable from './ScoreRatingTable'
import ExitAlert from './ExitAlert'
import EmptyScreen from './EmptyScreen'

export { ExitAlert, EmptyScreen, ScoreRatingItem, normalizerHooks, ScoreRatingTable, ApplyDataConfirmation }
export default Normalizer